export const getStories = ({ Stories }) => Stories

export const getIsExpand = (state) => getStories(state).isExpand

export const getStoriesCards = (state) => getStories(state).cards

export const getShowNewYearStories = (state) => getStories(state).showNewYearStories
